import { Component, inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { CustomModalComponent } from 'src/app/components/ui/custom-modal/custom-modal.component';
import { LoadingPopupComponent } from 'src/app/components/ui/loading-popup/loading-popup.component';
import { ErrorModalComponent } from 'src/app/components/ui/error-modal/error-modal.component';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';



@Component({
    selector: 'app-register',
    imports: [FormsModule, TranslateModule, CommonModule],
    templateUrl: './register.component.html',
    styleUrl: './register.component.scss'
})
export class RegisterComponent implements OnInit {

  userInfo = {
    name: '',
    email: '',
    password: '',
    last_name: '',
    alias: ''
  }

  modalLoad!: NgbModalRef;
  errorModal!: NgbModalRef;
  customModal!: NgbModalRef;

  rePass = '';
  error = false;
  errorPasswords = false;

  token: string | undefined;

  captchaRef = undefined;

  private router = inject(Router);
  private cdr = inject(ChangeDetectorRef);

  constructor(private _auth: AuthService,
    private _router: Router,
    private _modal: NgbModal,
    private _translate: TranslateService) {
    this.token = undefined;
  }
  ngOnInit(): void {
    this.errorPasswords = false;

  }


  onSubmit() {
    console.log('onSubmit');
    if (this.rePass != this.userInfo.password) {
      this.errorPasswords = true;
      this.cdr.detectChanges(); // Forzar detección de cambios
      console.log('error pass', this.errorPasswords);
      return;
    }
    this.errorPasswords = false;
    this.cdr.detectChanges(); // Forzar detección de cambios
    this.register();
  }

  // Método para validar contraseñas cuando pierden el foco
  validatePasswords() {
    // Solo validar si ambos campos tienen contenido
    if (this.rePass && this.userInfo.password) {
      this.errorPasswords = this.rePass !== this.userInfo.password;
      this.cdr.detectChanges();
    } else {
      // Limpiar error si algún campo está vacío
      this.errorPasswords = false;
      this.cdr.detectChanges();
    }
  }

  async checkRecaptcha(event: string): Promise<void> {
    this.token = event;
    if (this.token) {
      this.register();
    }
  }

  register() {

    this.modalLoad = this._modal.open(LoadingPopupComponent);

    this._auth.register(this.userInfo)
      .then(async user => {
        let _displayName = this.userInfo.name + " " + this.userInfo.last_name;
        this._auth.updateProfile(_displayName);
        //Hacer un resend validation para que le llegue un email de validación.
        this._auth.verifyEmail();
        this.modalLoad.close();
        this.customModal = this._modal.open(CustomModalComponent);
        this.customModal.componentInstance.title = '';
        this.customModal.componentInstance.description = this._translate.instant("register_success");
        this.customModal.closed.subscribe(() => {
          this._router.navigate(['/login']);
        });
      }, err => {
        this.modalLoad.close();
        this.errorModal = this._modal.open(ErrorModalComponent);
        this.errorModal.componentInstance.description = err.message;
      });
  }


  navigateToLogin(): void {
    console.log('Navegando a login...');
    this.router.navigate(['/login']);
  }
}
